import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaRobot, FaUser, FaEnvelope, FaBars, FaTimes } from 'react-icons/fa';
import SocialMedia from './SocialMedia';
import { IoLogInSharp, IoLogOutSharp } from "react-icons/io5";
import { getAuth, signOut } from "firebase/auth";
import { useAuthState } from 'react-firebase-hooks/auth';
import Logo from './Logo';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const auth = getAuth();
  const [user] = useAuthState(auth);
  const navigate = useNavigate();

  const handleLogout = () => {
    signOut(auth).then(() => {
      navigate('/login');
    }).catch((error) => {
      console.error('Error logging out:', error);
    });
  };

  return (
    <>
      <div
        className={`fixed top-0 left-0 w-64 h-[100vh] bg-gradient-to-tl from-[#FF8A08] to-[#FF6500] text-white flex flex-col z-50 transform ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        } transition-transform duration-300 ease-in-out lg:translate-x-0`}
      >
        <div className="p-4 text-xl font-bold flex justify-between items-center">
          <Logo />
          <FaTimes className="cursor-pointer lg:hidden absolute top-2 right-2" onClick={toggleSidebar} />
        </div>
        <div className='flex flex-col gap-2'>
        <Link to="/" className="p-4 flex items-center space-x-3 transition-all hover:bg-gradient-to-b bg-gradient-to-t from-[#FF8A08] to-[#FF6500]" onClick={toggleSidebar}>
          <FaRobot size={22} />
          <span className='text-lg font-semibold'>GPT</span>
        </Link>
        <Link to="/developer" className="p-4 flex items-center space-x-3 transition-all hover:bg-gradient-to-b bg-gradient-to-t from-[#FF8A08] to-[#FF6500]" onClick={toggleSidebar}>
          <FaUser size={22} />
          <span className='text-lg font-semibold'>About Us</span>
        </Link>
        <Link to="/contact" className="p-4 flex items-center space-x-3 transition-all hover:bg-gradient-to-b bg-gradient-to-t from-[#FF8A08] to-[#FF6500]" onClick={toggleSidebar}>
          <FaEnvelope size={22} />
          <span className='text-lg font-semibold'>Contact Us</span>
        </Link>
        {user ? (
          <Link>
          <div className="p-4 flex items-center space-x-3 transition-all hover:bg-gradient-to-b bg-gradient-to-t from-[#FF8A08] to-[#FF6500]" onClick={handleLogout}>
            <IoLogOutSharp size={22} />
            <span className='text-lg font-semibold'>Logout</span>
          </div></Link>
        ) : (
          <Link to="/login" className="p-4 flex items-center space-x-3 transition-all hover:bg-gradient-to-b bg-gradient-to-t from-[#FF8A08] to-[#FF6500]" onClick={toggleSidebar}>
            <IoLogInSharp size={22}/>
            <span className='text-lg font-semibold'>Login</span>
          </Link>
        )}
        <div className='absolute bottom-2 left-3'>
          <SocialMedia />
        </div>
      </div>
      </div>

      <FaBars
        className="text-[#FF6500] text-2xl fixed top-4 right-4 cursor-pointer lg:hidden z-50"
        onClick={toggleSidebar}
      />
    </>
  );
};

export default Sidebar;
